(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-notification/assets/javascripts/notification-api.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-notification/assets/javascripts/notification-api.js');

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getConfigValues = function getConfigValues() {
  if (svs.components && svs.components.adobeTargetNotification && svs.components.adobeTargetNotification.data && svs.components.adobeTargetNotification.data.config) {
    return svs.components.adobeTargetNotification.data.config;
  }
  throw new Error('Missing config for adobe target notification api');
};
var getEndpoint = function getEndpoint(_ref) {
  var serverDomain = _ref.serverDomain,
    client = _ref.client,
    sessionId = _ref.sessionId;
  return "https://".concat(serverDomain, "/rest/v1/delivery?client=").concat(client, "&sessionId=").concat(sessionId);
};
var apiCall = function apiCall(_ref2) {
  var config = _ref2.config,
    data = _ref2.data,
    _ref2$callback = _ref2.callback,
    callback = _ref2$callback === void 0 ? function () {} : _ref2$callback,
    _ref2$errorCallback = _ref2.errorCallback,
    errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;
  if (config.tntId) {
    if (window.navigator.sendBeacon) {
      var status = window.navigator.sendBeacon(getEndpoint(config), JSON.stringify(data));
      if (status) {
        callback({});
      } else {
        errorCallback({
          status: 400
        }, 'Couldnt add call to sendBeacon queue');
      }
    } else {
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        cache: false,
        url: getEndpoint(config),
        data: JSON.stringify(data),
        dataType: 'json',
        success: callback,
        error: errorCallback
      });
    }
  }
};
var createNotificationRequestObject = function createNotificationRequestObject(_ref3) {
  var tntId = _ref3.tntId,
    timestamp = _ref3.timestamp,
    propertyToken = _ref3.propertyToken,
    mboxName = _ref3.mboxName,
    tokens = _ref3.tokens,
    type = _ref3.type;
  var response = {
    id: {
      tntId: tntId
    },
    property: {
      token: propertyToken
    },
    context: {
      channel: 'web'
    },
    notifications: [{
      id: "".concat(mboxName, "Notification"),
      timestamp: timestamp,
      mbox: {
        name: mboxName
      },
      tokens: tokens,
      type: type
    }]
  };



  return response;
};
svs.components.adobeTargetNotification.display = function (_ref4, callback) {
  var mboxName = _ref4.mboxName,
    tokens = _ref4.tokens,
    state = _ref4.state,
    errorCallback = _ref4.errorCallback;
  var config = getConfigValues();
  var data = createNotificationRequestObject(_objectSpread(_objectSpread({}, config), {}, {
    mboxName: mboxName,
    tokens: tokens,
    state: state,
    type: 'display'
  }));
  apiCall({
    data: data,
    config: config,
    callback: callback,
    errorCallback: errorCallback
  });
};
svs.components.adobeTargetNotification.click = function (_ref5, callback) {
  var mboxName = _ref5.mboxName,
    tokens = _ref5.tokens,
    errorCallback = _ref5.errorCallback;
  var config = getConfigValues();
  var data = createNotificationRequestObject(_objectSpread(_objectSpread({}, config), {}, {
    mboxName: mboxName,
    tokens: tokens,
    type: 'click'
  }));
  apiCall({
    data: data,
    config: config,
    callback: callback,
    errorCallback: errorCallback
  });
};

 })(window);